export const compareAddresses = (addressA: string, addressB: string) =>
  addressA.toLowerCase() === addressB.toLowerCase();
